import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/1.jpg';
// import p2 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/2.jpg';
// import p3 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/3.jpg';
// import p4 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/4.jpg';
// import p5 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/5.jpg';
// import p6 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/6.jpg';

// import Ecoclub2023 from 'views/EnvironmentDay2023/Ecoclub2023';


import { Typography } from '@mui/material';
import Container from 'components/Container';
// import Sidebar2023 from './Sidebar2023';

import Sidebar2024 from '../EkBharat2023/components/Sidebar2024';
import Archive2023 from '../EkBharat2023/components/Sidebar2023/Archive2023';
import Sidebar2025 from '../EkBharat2023/components/Sidebar2025';



const IndependenceDay2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/4.webp`;
  const p5  = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/5.webp`;
  const p6  = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/6.webp`;
  const p7  = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/7.webp`;
  const p8  = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/8.webp`;
  const p9  = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/9.webp`;
  const p10 = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/10.webp`;
  const p11 = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Independence/11.webp`;


  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
},
{
  src: p10,
  source: p10,
  rows: 1,
  cols: 1,
},
{
  src: p11,
  source: p11,
  rows: 1,
  cols: 1,
}
      
  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h5' align='center' >
      Independence Day
                                </Typography>
                                <br></br>
                                {/* <Typography variant='h7' align='justify' >
                                Class 4: Diversity Montage
                                Class 5: Continental Montage 

                                </Typography> */}
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Classes: Pre-Primary & Class 1 to 5  &  Date: 20 August 2025
        </Typography>
<br/>
    <Typography variant={'subtitle1'} align={'center'}>
       <center><strong>Echoes of Freedom – Celebrating Independence Day</strong></center>
        </Typography>

        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “Where the mind is without fear and the head is held high, into that heaven of freedom, my Father, let my country awake.” – Rabindranath Tagore

<br/>
        </Typography>
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
       <strong>Independence Day Celebration – Honouring the Spirit of India</strong>

       On Wednesday, 20th August 2025, our school reverberated once again with the spirit of patriotism as we came together to celebrate the 79th Independence Day of our nation, a celebration marked by the students of Pre-Primary and Classes 1-5.  The day was not just a commemoration of history, but a heartfelt tribute to the sacrifices, courage and unity that gave India her freedom.
       The celebration was designed to immerse children from Pre-Primary to Class 5 in the richness of our country’s heritage through dance, music, role-play, and inspiring words. Each performance was a vibrant reminder that patriotism is not confined to pages of history, but lives on in every young heart that beats for the nation. 
        <br></br>
        <strong>Classes I and II – Remembering the Heroes of Pre Independence and Post-Independence</strong>

        The students of Classes I and II paid homage to India’s brave sons and daughters through fancy dress and heartfelt speeches on freedom fighters. From Mahatma Gandhi’s message of peace, to Rani Lakshmi Bai’s valour, and Bhagat Singh’s fiery call for freedom, the children brought history alive with innocence and sincerity. Their costumes, confidence, and words reflected both admiration and respect, reminding us that these heroes continue to inspire every generation.
        <br></br>
        <strong>Class III – Voices United in Song</strong>

        The children of Class III lifted their voices in harmony through a patriotic group song rendition. With passion in their tones and pride in their eyes, they sang of sacrifice, unity, and love for the nation. The melody echoed across the campus, filling every heart with renewed pride and gratitude for the priceless gift of freedom.
        <br></br>
        
        <strong>Classes IV and V – Living the Legacy of Iconic Personalities of our country</strong>

         The stage came alive with grandeur as Classes IV and V performed a role-play of Iconic Leaders . Clad in royal attire, the students portrayed leaders who lead India’s heritage with courage and wisdom. From their poised performances, the audience learned that the story of India is not just about freedom fighters but also about great personalities who preserved the dignity and culture of our country through time.
         The celebration reached its crescendo as the students joined hands in unity to walk for the iconic song “Mile Sur Mera Tumhara.” This beautiful moment symbolized the essence of India’s diversity and harmony—a nation of many voices, yet one soul.
        <br></br>

        <strong>Pre-Primary – A Dance of Devotion</strong>

        The tiniest stars of our school, the Pre-Primary children, graced the stage with a spirited patriotic dance. Dressed in the hues of the tricolour, their magnificent steps radiated love for the motherland. The audience was moved by their energy and charm, as they conveyed a simple yet powerful truth—that the seeds of patriotism are best sown in the earliest years of life.
        <br></br>
        
       <strong>More Than a Celebration – A Promise to the Nation</strong>
         
         The Independence Day programme was more than an event; it was an awakening of young minds to the responsibility they hold as citizens of tomorrow. Through dance, song, speeches, and role-play, our students learned that freedom is not just a gift to be enjoyed, but a legacy to be protected.
       <br></br>

         As the tricolour fluttered proudly in the morning breeze, every child and teacher stood with hearts brimming with pride, whispering a silent promise—to honour the sacrifices of the past and build a future worthy of them.
        <br></br>

        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “In every child’s heart beats the rhythm of freedom, in every voice echoes the song of India.”

       <br/>
        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “Every child, a spark of India’s bright tomorrow”

       <br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <Sidebar2025/>
             </Box>

             <Box marginBottom={4}>
               <Archive2023 />
             </Box>

    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default IndependenceDay2025;